import AppRecord from './AppRecord.js'

class Currency extends AppRecord {
  get controller_name(){
    return 'CurrenciesController'
  }
}

export default Currency
